import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=0f4604e4&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
import style0 from "./Basic.vue?vue&type=style&index=0&id=0f4604e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4604e4",
  null
  
)

export default component.exports